import { notifyError } from "../stores/notifications";
import { getTranslation } from "../i18n";

export const handleError = (e) => {
    console.error(e);
    notifyError(getTranslation("Notifications.Error"), e.message);
};
